import FilterRegister from "../../../../components/filter/register-basic";
import reqInstagramPosts from "../../../../services/reqMultiTenant/reqInstagramPosts";

import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import FormWhatsApp from "../form";

const MainRegisterInstagramPosts = () => {
	const options = {
		id: "id_post", //usado para saber qual field usar para atualizar
		ident: "instagramPostsConnect", //usado para definir os event listners
		identFilter: "filterInstagramPosts", //usado para definir os event listners
		title: "Posts Instagram",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "url_imagem", label: "Imagem", align: "left", format: "image" },
			{ key: "mensagem_comentario_1", label: "Retorno Comentário", align: "left", width: "250px" },
			{ key: "mensagem_dm", label: "Retorno na DM", align: "left", width: "250px" },
			{ key: "ativo", label: "Ativo", align: "left", format: "badgeAtivo" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Gatilho", value: "mensagem_gatilho" }],
	};

	//#region Funções de acesso a dados do componente
	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const responseComplement = await reqInstagramPosts.listPaginate(param, paramValue, active, newPage);

		return responseComplement;
	};

	const fetchID = async (currentId) => {
		const responseComplement = await reqInstagramPosts.listID(currentId);

		return responseComplement;
	};

	const insert = async (data) => {
		const response = await reqInstagramPosts.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormWhatsApp} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterInstagramPosts;

// import FilterRegister from "../../../../components/filter/register-basic";
// import reqInstagram from "../../../../services/reqMultiTenant/reqInstagram";
// import reqWhatsapp from "../../../../services/reqMultiTenant/reqWhatsApp";
// import { RegisterProvider } from "../../register-matrix/context-api";
// import MainRegisterMatrix from "../../register-matrix/main";
// import FormWhatsApp from "../form";

// const MainRegisterInstagram = () => {
// 	const options = {
// 		id: "id_instagram", //usado para saber qual field usar para atualizar
// 		ident: "instagramConnect", //usado para definir os event listners
// 		identFilter: "filterInstagram", //usado para definir os event listners
// 		title: "Instagram Instância",
// 		subTitle: "Cadastro",
// 		tableColumns: [
// 			{ key: "descricao", label: "Nome da instância", align: "left", width: "250px" },
// 			// { key: "telefone", label: "Telefone", align: "left" },
// 			{ key: "actions", label: "", align: "right" },
// 		],
// 		hasActive: true,
// 		parametersFilter: [{ id: 1, label: "Nome da instância", value: "descricao" }],
// 	};

// 	//#region Funções de acesso a dados do componente
// 	const fetch = async (filterData, newPage) => {
// 		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

// 		const responseComplement = await reqInstagram.listPaginate(param, paramValue, active, newPage);

// 		return responseComplement;
// 	};

// 	const fetchID = async (currentId) => {
// 		const responseComplement = await reqInstagram.listID(currentId);

// 		return responseComplement;
// 	};

// 	const insert = async (data) => {
// 		const response = await reqInstagram.insert(data);

// 		return response;
// 	};

// 	return (
// 		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
// 			<MainRegisterMatrix FormComponent={FormWhatsApp} FormFilter={FilterRegister} />
// 		</RegisterProvider>
// 	);
// };

// export default MainRegisterInstagram;
